<template>
  <div>
    <div class="row mb-3">
      <div class="col-12">
        <button
            type="button"
            class="btn btn-success"
            data-dismiss="modal"
            @click="openAddEditModal()"
        >
          Agregar evaluación de desempeño baja (menor a 3)
        </button>
      </div>
    </div>

    <app-table :id="tableId" :options="options" @action="getListAction"/>

    <low-performance-eval-modal
        v-if="isAddEditModalActive"
        :table-id="tableId"
        :selected-url="selectedUrl"
        @close-modal="closeAddEditModal"
        modalTitle="Añadir evaluación de desempeño"
        editModalTitle="Editar evaluación de desempeño"
    />

    <app-confirmation-modal
        v-if="deleteConfirmationModalActive"
        modal-id="modal-delete"
        @confirmed="confirmed"
        @cancelled="cancelled"
        title="Confirmación"
        message="¿Desea eliminar este registro?"
    />

  </div>

</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import {LowPerformanceEvaluationTableHelpers as TableHelpers} from "./LowPerformanceEvaluationTableHelpers"
export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  name: "Index",
  props: {
    detailId: String
  },
  data(){
    return{
      tableId: "low-performance-detail-table",
      rowData: {},
      deleteLoader: false,
      selectedUrl: "",
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      options: {
        name: "low-performance-detail-table",
        url: `/evaluator/maintenance/low-performance/eval-all/`,
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "low-performance-eval-modal",
            modalId: "low-performance-eval-modal",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "low-performance-eval-modal",
            modalId: "low-performance-eval-modal",
          }
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
        datatableWrapper: false
      }
    }
  },
created() {
  this.options.columns = [...this.tableColumns, this.actionObj];
  this.options.url = this.options.url + this.detailId;
},
  watch: {
    "$store.state.evaluatorReview.detailId": function (){
      const originalUrl = "/evaluator/maintenance/low-performance/eval-all/";
      this.options.url = "";
      this.options.url = originalUrl + this.$store.state.evaluatorReview.detailId.toString();
    }
  },

  methods: {
    updateUrl(value){
      this.options.url = this.options.url + value;
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      this.rowData = rowData;
      if (actionObj.title == this.$t("delete")) {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `/evaluator/maintenance/low-performance/eval/${this.rowData.id}`;
        this.openAddEditModal();
      }
    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#low-performance-eval-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.deleteLoader = false;
      this.reSetData();
    },
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    confirmed(){
      let url = `/evaluator/maintenance/low-performance/eval/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
          .then((response) => {
            this.deleteLoader = false;
            $("#modal-delete").modal("hide");
            this.cancelled();
            this.$toastr.s(this.$t("deleted_success"));
          })
          .catch(({error}) => {
          })
          .finally(() => {
            this.$hub.$emit("reload-" + this.tableId);
          });
    }
  }
}
</script>

<style scoped>

</style>